module.exports = __webpack_public_path__ + "img/Lato-Light.43ff1cd6.svg";